import PropTypes from 'prop-types'
import React from 'react'
import omit from 'lodash/omit'
import classNames from 'classnames'

import RouterLink from 'base/components/router_link'

export const Icons = {
  RIGHT_ARROW: 'RIGHT_ARROW',
  EYE_OPEN: 'EYE_OPEN',
  X: 'X',
  RESET: 'RESET',
}

function Link(props) {
  const className = classNames(
    'everlane-brand-link',
    {
      'everlane-brand-link--right-arrow': props.icon === Icons.RIGHT_ARROW,
      'everlane-brand-link--eye-open': props.icon === Icons.EYE_OPEN,
      'everlane-brand-link--x': props.icon === Icons.X,
      'everlane-brand-link--reset': props.icon === Icons.RESET,
      'everlane-brand-link--inherit-color': props.inheritColor,
      'everlane-brand-link--disabled': props.disabled,
    },
    props.className,
  )

  const onClick = event => {
    if (props.onClick) {
      props.onClick(event)
    }
  }

  let Component = 'button'
  if (props.component) {
    Component = props.component
  } else if (props.href) {
    Component = RouterLink
  }

  const safeProps = omit(props, ['component', 'inheritColor'])

  return (
    <Component {...safeProps} onClick={onClick} className={className}>
      {props.children}
    </Component>
  )
}

Link.displayName = 'Link'
Link.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.oneOf(Object.keys(Icons)),
  component: PropTypes.node,
  inheritColor: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
}

export default Link
